import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { PositionSchema } from '../../shared/position.schema';
/**
 * POST /api/v2/process/:id/draft/events — create an event, floating
 * unless `attachToStepId` is set. `position` seeds `ProcessLayout.generatedNodePositions`
 * under `event-<eventId>` so the new node renders at the requested spot
 * without a follow-up layout round-trip.
 *
 * `attachToStepId` names a draft step or assignment (its `_id`): the new
 * event is created attached to it in the same request, so the add is one
 * undo entry.
 *
 * The response envelope carries the new event ROW (the
 * `ProcessDraftEventNodeSchema` arm, keyed by `stableStepId`) in `nodes`
 * and its `stableStepId` in `createdNodeIds`; with `attachToStepId`, the
 * attached node follows the row in `nodes`.
 */ export const AddDraftEventRequestSchema = z.object({
    eventType: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    position: PositionSchema,
    attachToStepId: ObjectIdSchema.optional()
});

//# sourceMappingURL=add-draft-event.schema.js.map